import React, { Component } from 'react';
import ComboBox from '../combo-box'
import TextField from "material-ui/TextField"
import { withStyles } from 'material-ui/styles';
import CardContent from 'material-ui/Card/CardContent';
import Card from 'material-ui/Card';
import Button from 'material-ui/Button';
import CardActions from 'material-ui/Card/CardActions'
import CloseIcon from 'material-ui-icons/Close';
import IconButton from 'material-ui/IconButton/IconButton';
import Typography from 'material-ui/Typography';
import green from 'material-ui/colors/green';
import Portal from 'material-ui/Portal'
import SaveIcon from 'material-ui-icons/Save';
import { CircularProgress } from 'material-ui/Progress';
import Dialog, { DialogTitle, DialogContentText,DialogContent,DialogActions } from 'material-ui/Dialog';

import { ajaxPost } from '../ajax';
var GetBlankEmployee = require('./BlankEmployee');


const styles = theme => ({
    title:
    {
        color:"white",
        flex:1,
        marginTop:20,
    },
    card:
        {
            margin: 10
        },
    container: {
        display: 'flex',
        flexWrap: 'wrap',
    },
    textField: {
        marginLeft: theme.spacing.unit,
        marginRight: theme.spacing.unit,
        marginTop: 15,
        width: 200,
    },
    menu: {
        width: 200,
    },
    button: {
        '&:hover': {
          backgroundColor: green[700],
        },
      },
      fabProgress: {
        color: green[500],
        position: 'absolute',
        top: '50%',
        left: '50%',
        marginTop: -25,
        marginLeft: -25,
          },
      wrapper: {
        margin: theme.spacing.unit,
        position: 'relative',
        display:'inline-flex',
      },
      dialog:
      {
          margin:"20px 20px 40px 20px"
      },
      
});


class EmployeeForm extends Component {
    state =
        {
            employee: null,
            saving:false,
            dialog:false,
            dialogContent:null,
            dialogTitle:'',
            err:{},
        }

    constructor(props) {
        super(props);
        this.state.employee = props.employee;

        this.loadGroups("Position", this.positionsList);
        this.loadGroups("Location", this.locationsList);

        if (props.getRef != null)
            props.getRef(this);
    }


    loadGroups = (category, list) => {
        ajaxPost({
            url: '/EmployeeAPI/LoadCategory',
            data: category,
            onError: ()=>{},
            onSuccess: data => {
                var options = data.map((item, index) => {
                    return { label: item, value: item };
                });
                list.options = options;
            },
            finally: ()=>
            {
            }
        }
        )
        
    }

    
    positionsList =
        {
            options: []
        }

    locationsList = { options: [] }


    handleChange = name => event => {
        var current = this.state.employee;
        current[name] = event.target.value;
        this.setState({ employee: current });
    };

    handleComboChange = (name, val) => {
        var current = this.state.employee;
        current[name] = val;
        this.setState({ employee: current });
    }

    onCloseDialog = () =>
    {
        this.setState({dialog:false});
        this.props.onUpdateComplete(this.state.employee);
    }

    continueWithSave = (data) =>
    {
        var {classes} = this.props;
        var addMode = this.state.employee.EmployeeID === -1;
        var _this2 = this;

        ajaxPost({
            url: '/EmployeeAPI/' + (this.state.employee.EmployeeID === -1 ? 'SaveNew' : 'Update'),
            data: data,
            onError: ()=>{},
            onSuccess: res => {
                this.state.employee.EmployeeID = res.Payload.EmployeeID;
                this.state.employee.FullName = res.Payload.FullName;
                
                _this2.setState({dialogTitle:"Save"})
                _this2.setState({dialogContent:(
                    <div className={classes.dialog}>
                    <Typography>Employee information has been updated successfully</Typography>
                    </div>
                 )});
                _this2.setState({dialog:true});
            },
            finally: ()=>
            {
                this.setState({saving:false});
            }
        }
        )

    }

    onSave = () => {
        var emp = this.state.employee;
        var {classes} = this.props;

        var err = {}
        if( emp.EmployeeNo.trim()=="")
            err.EmployeeNo = "This field is required";

        if( emp.Username.trim()=="")
            err.Username = "This field is required";

        if( emp.LastName.trim()=="")
            err.LastName = "This field is required";
        
        if( emp.FirstName.trim()=="")
            err.FirstName = "This field is required";

        if( err.EmployeeNo != null ||
            err.Username != null ||
            err.LastName != null ||
            err.FirstName != null )
            {
                this.setState({err:err});
                return;
            }

        this.setState({saving:true});

        var data =
            {
                EmployeeID: emp.EmployeeID,
                LastName: emp.LastName,
                FirstName: emp.FirstName,
                MiddleName: emp.MiddleName,
                EmployeeNo: emp.EmployeeNo,
                Status: "ACTIVE",
                AccessNumber: emp.AccessNumber,
                EmployeeInfo:
                    {
                        Department: emp.Department,
                        Position: emp.Position,
                        Location: emp.Location,
                        Username: emp.Username,
                        RoleType: emp.RoleType,
                        Company: emp.Company,
                        AccessGroup:emp.AccessGroup,
                        PIN:emp.PIN,
                    }
            };

            ajaxPost({
                url: '/EmployeeAPI/Validate',
                data: data,
                onError: ()=>{},
                onSuccess: validate => {
                    if( validate.empty == true )
                    {
                        this.continueWithSave(data)
                    }
                    else
                    {
                        this.setState({saving:false});
                        this.setState({err:validate});
                        return;
                    }
                },
                finally: ()=>{}
            }
            )
        }

    filterSuggestions(value, list) {
        const inputValue = value.trim().toLowerCase();
        const inputLength = inputValue.length;
        let count = 0;

        return inputLength === 0
            ? []
            : list.options.filter(suggestion => {
                const keep =
                    count < 5 && suggestion.label.toLowerCase().slice(0, inputLength) === inputValue;

                if (keep) {
                    count += 1;
                }

                return keep;
            });
    }

    componentWillReceiveProps(nextProps) {
        this.setState({ employee: nextProps.employee });
    }

    createCombo = (params) =>
    {
        const { classes } = this.props;

        return (
        <TextField
            select
            label={params.label}
            className={classes.textField}
            value={params.value}
            onChange={params.onChange}
            SelectProps={{
                native: true,
                MenuProps: {
                    className: classes.menu,
                },
            }}
            margin="normal"
        >
        {params.options}
            ))}
        </TextField>

    )

    }

    render() {
        const { classes } = this.props;

        return (
            <div>
            <Portal container={this.props.toolbar}>
                <Typography variant="title" color="inherit" className={classes.title}>
                {this.state.employee.EmployeeID == -1 ? 'Add new employee' : this.state.employee.FullName}
                </Typography>
                <div className={classes.wrapper}>
                    <IconButton style={{ "color": "#606060" }} disabled={this.state.saving} color="inherit" className={classes.button} onClick={this.onSave}>
                        <SaveIcon />
                    </IconButton>
                    {this.state.saving && <CircularProgress size={50} className={classes.fabProgress} />}
                </div>
                <div className={classes.wrapper}>
                    <IconButton style={{ "color": "#606060" }} disabled={this.state.saving}  className={classes.button} color="inherit" 
                    onClick={this.props.onCloseForm}>
                        <CloseIcon />
                    </IconButton>
                </div>
            </Portal>


            <Card>
                <CardContent style={{ "background": "transparent" }}>
                    {
                        [
                            [
                                { cap: "AIMS ID", prop: "EmployeeNo" },
                                { cap: "Username", prop: "Username" },
                            ],
                            [
                                { cap: "LastName", prop: "LastName" },
                                { cap: "FirstName", prop: "FirstName" },
                                { cap: "MiddleName", prop: "MiddleName" },
                            ],

                        ]
                            .map(grp =>
                                (
                                    <div className={classes.container}>
                                        {
                                            grp.map(item =>
                                                (
                                                    <TextField className={classes.textField}
                                                        error={this.state.err[item.prop] != null}
                                                        value={this.state.employee[item.prop]}
                                                        label={item.cap}
                                                        helperText={this.state.err[item.prop]}
                                                        onChange={this.handleChange(item.prop).bind(this)} />
                                                ))
                                        }
                                    </div>
                                )
                            )
                    }

                    <div className={classes.container} >
                    {this.createCombo(
                        {
                        label:"User Type",
                        value:this.state.employee.RoleType,
                        onChange:this.handleChange('RoleType'),
                        options:[
                            <option key="USER" value="USER">USER</option>,
                            (global.userType == "ADMIN" &&
                            [
                                <option key="SUPERVISOR" value="SUPERVISOR">SUPERVISOR</option>,
                                <option key="ADMIN" value="ADMIN">ADMIN</option>
                            ])
                            ]
                        }
                    )}
                    </div>


                    <div className={classes.container} >
                        {this.createCombo(
                            {
                            label:"Department",
                            value:this.state.employee.Department,
                            onChange:this.handleChange('Department'),
                            options:[
                                <option key="INFLIGHT" value="Inflight Services">Inflight Services</option>,
                                ((global.userType == "ADMIN" || global.department == 'Flight Operations') &&
                                    <option key="FLIGHTOPS" value="Flight Operations">Flight Operations</option>
                                ),
                                ((global.userType == "ADMIN" ) &&
                                    <option key="MANAGEMENT" value="Management">Management</option>
                                )
                            ]
                            }
                        )}
                        {
                            [
                            { cap: "Position", list: this.positionsList },
                            { cap: "Location", list: this.locationsList },
                            ].map(item =>
                                (
                                    <ComboBox
                                        label={item.cap}
                                        value={this.state.employee[item.cap]}
                                        onChange={this.handleComboChange.bind(this, item.cap)}
                                        getSuggestions={(value) => {
                                            return this.filterSuggestions(value, item.list);
                                        }
                                        } />
                                ))
                        }
                        <TextField
                            select
                            label="Company"
                            className={classes.textField}
                            value={this.state.employee.Company}
                            onChange={this.handleChange('Company')}
                            SelectProps={{
                                native: true,
                                MenuProps: {
                                    className: classes.menu,
                                },
                            }}
                            margin="normal"
                        >
                        {global.userType == "ADMIN" ?  
                            [
                            <option key="5J" value="5J">5J</option>,
                            <option key="CEBGO" value="CEBGO">CEBGO</option>
                            ]
                            :
                            <option key={global.company} value={global.company}>{global.company}</option>
                        }
                            ))}
                        </TextField>
                    </div>
                    <div className={classes.container} >
                        <TextField className={classes.textField}
                            value={this.state.employee.AccessGroup}
                            label="Access Group"
                            onChange={this.handleChange("AccessGroup").bind(this)} />
                        <TextField className={classes.textField}
                            value={this.state.employee.PIN}
                            label="Device PIN"
                            onChange={this.handleChange("PIN").bind(this)} />
                        <TextField className={classes.textField}
                            value={this.state.employee.AccessNumber}
                            label="Device ID"
                            disabled="true"
                             />
                    </div>
                </CardContent>
            </Card>
            <Dialog open={this.state.dialog}>
                <DialogTitle>{this.state.dialogTitle}</DialogTitle>
                <DialogContent>
                <DialogContentText>
                    {this.state.dialogContent}
                </DialogContentText>
            </DialogContent>
                <DialogActions>
            <div className={classes.wrapper}>
                <Button 
                color="primary" className={classes.button} onClick={this.onCloseDialog.bind(this)}>
                OK
                </Button>
            </div>
            </DialogActions>
            </Dialog>

            </div>
        )
    }
}
export default withStyles(styles)(EmployeeForm);



// WEBPACK FOOTER //
// ./src/admin/EmployeeForm.js